module.exports = __webpack_public_path__ + "static/media/deal-bg.f5d41735.jpg";